import React from 'react'
import { Typography } from '@mui/material'
import { useStyles } from './CanvasMigrationPanel.styles'
import { CanvasMigrationTaskCard } from './CanvasMigrationTaskCard'
import { CanvasMigrationJobView } from './canvasMigrationTypes'
import { sortMigrationTasks } from './parseCanvasMigrationResponse'

/**
 * Post-start screen. The card count follows `job.tasks`, which the backend
 * decides, so nothing here assumes a fixed set of migration steps. Cards stay
 * in created-date order so a running poll cannot move them around the grid.
 */
export const CanvasMigrationProgressView: React.FC<{
  job: CanvasMigrationJobView
}> = ({ job }) => {
  const { classes } = useStyles()
  const tasks = sortMigrationTasks(job.tasks)

  if (!tasks.length) {
    return (
      <Typography
        className={classes.emptyTasks}
        data-testid="canvas-migration-no-tasks"
      >
        Preparing migration tasks…
      </Typography>
    )
  }

  return (
    <div className={classes.grid} data-testid="canvas-migration-task-grid">
      {tasks.map(task => (
        <CanvasMigrationTaskCard key={task.taskId} task={task} />
      ))}
    </div>
  )
}
